import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { Account } from 'dashboard/models/account';
import { Environment } from 'dashboard/models/environment';
import { ExporterAccount, ExporterFileType } from 'dashboard/models/exporter';
import { AccountsFilterParams, saveAccounts } from 'dashboard/redux/slices/accounts';
import { ApiEndpoint, ApiModel, PaginationParams } from 'lib/interfaces/api';

export function loadAccountsList({
  currentEnvironment,
  currentPage,
  pageSize,
  filters,
  sortParams,
  abortSignal,
}: {
  currentEnvironment: Environment;
  currentPage: number;
  pageSize: number;
  filters: AccountsFilterParams;
  sortParams: SortParams;
  abortSignal?: AbortSignal;
}) {
  return async (dispatch: Dispatch) => {
    const params = {
      ...createParamsForList(currentEnvironment, filters, sortParams),
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
    } as any;

    const accountsResponse = await SessionClientDashboard.listResource<Account, PaginationParams>(
      ApiEndpoint.Account,
      params,
    );

    const accounts = accountsResponse.data;
    const paginationParams = accountsResponse.meta;

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(saveAccounts({ accounts, environment: currentEnvironment, paginationParams }));
  };
}

export const loadExporterAccount =
  ({
    currentEnvironment,
    filters,
    sortParams,
    fileType,
  }: {
    currentEnvironment: Environment;
    filters: AccountsFilterParams;
    sortParams: SortParams;
    fileType: ExporterFileType;
  }) =>
  async () => {
    const params = createParamsForList(currentEnvironment, filters, sortParams, fileType);

    await SessionClientDashboard.postResourceCreate<ExporterAccount>({
      type: ApiModel.ExporterAccount,
      attributes: {
        ...params,
      },
    });
  };

function createParamsForList(
  currentEnvironment: Environment,
  accountFilters: AccountsFilterParams,
  accountSortParams: SortParams,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  fileType: ExporterFileType = null,
) {
  const {
    updatedAtStart,
    updatedAtEnd,
    accountStatusIds,
    accountTypeIds,
    tagIds,
    tagsConditions,
    omni,
    listIds,
  } = accountFilters;
  const { sort, shouldSortDescending } = accountSortParams;

  return {
    'file-type': fileType,
    filter: {
      'environment-id': currentEnvironment.id,
      accountTypeIds,
      accountStatusIds,
      tagIds,
      tagsConditions,
      omni,
      listIds,
      'updated-at-start': updatedAtStart && updatedAtStart.toString(),
      'updated-at-end': updatedAtEnd && updatedAtEnd.toString(),
    },
    // We want to keep omnisearch relevance ordering, instead of sorting
    sort: omni ? '' : `${shouldSortDescending ? '-' : ''}${sort}`,
  };
}
